import { render, staticRenderFns } from "./goxuanpin.vue?vue&type=template&id=0950dfec&scoped=true&"
import script from "./goxuanpin.vue?vue&type=script&lang=js&"
export * from "./goxuanpin.vue?vue&type=script&lang=js&"
import style0 from "./goxuanpin.vue?vue&type=style&index=0&id=0950dfec&scoped=lang&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0950dfec",
  null
  
)

export default component.exports